import { Button, Card, Tooltip } from '@sede-enterprise/shell-ds-react-framework'
import React, { useContext } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import "./TopCmlCard.css"
import { UnitContext } from '../../../../App';
import { mmOrMiles, round } from '../../../../util/helperFunctions';
import { DE_INSTALL_HELP, DE_INSTALLED_PROD_UNIT } from '../../../../util/helperTexts';
import * as R from "rambda";


const TopCmlCard = ({ cmlData }) => {
    const context = useContext(UnitContext);
    const cells = [
        {
            id: "site",
            label: "Site",
            content: (row) => row.site || "—",
        },
        {
            id: "unit",
            label: "Unit",
            content: (row) => row.unit || "—",
        },
        {
            id: "equipment",
            label: "Equipment",
            content: (row) => row.equipment || "—",
        },
        {
            id: "corrosionLoop",
            label: "Corrosion Loop",
            content: (row) =>
                row.corrosionLoop ? (
                    <Link
                        className="link"
                        to={`/cls/${encodeURIComponent(row.corrosionLoop)}/details`}
                        id="top-cml-id-6"
                    >
                        {row.corrosionLoop}
                    </Link>
                ) : null,
        },
        {
            id: "cmlName",
            label: "CML",
            content: (row) => {

                return row.conditionMonitoringLocation ? (
                    <Link
                        className="link"
                        to={`/cmls/${encodeURIComponent(row.conditionMonitoringLocation)}/details`}
                        id="top-cml-id-7"
                    >
                        {row.cmLocationName || "—"}
                    </Link>
                ) : null

            }
                
        },
        {
            id: "sensor",
            label: "Sensor",
            content: (row) => (
                <Link
                    className={
                        row.uninstalled ? "link redContent" : "link blueContent"
                    }
                    to={`/home/${encodeURIComponent(row.id)}/details`}
                    id='sensor-list-id-3'
                >
                    {row.isRealSensor && row.name}
                    {!row.isRealSensor && (
                        <span
                            title="This CML has no Sensor installed"
                            className="redContent"
                            id='sensor-list-id-4'
                        > No Sensor
                        </span>
                    )}
                </Link>
            ),
        },
        {
            id: "latestCorrosionRatePredictionFromLiveModel",
            label: `Latest PCR (${mmOrMiles(context.units)})`,
            content: () => {
                const value = cmlData.latestCorrosionRatePredictionFromLiveModel;
                return value != null
                    ? round(context.units ? 39.3700787402 * value : value, 3)
                    : "—";
            },
        },
        {
            id: "averageCorrosionRatePredictionFromLiveModel",
            label: `Average PCR (${mmOrMiles(context.units)})`,
            content: () => {
                const value = cmlData.averageCorrosionRatePredictionFromLiveModel;
                return value != null
                    ? round(context.units ? 39.3700787402 * value : value, 3)
                    : "—";
            },
        },
    ];


    return (
        <Card className='top-cmls-card' bodyPadding={false} id='top-cml-id-1'>
            <div className='top-cmls-body' id='top-cml-id-2'>
                {
                    cells.map((cell) => (
                        <div className='top-cmls-data' key={cell.id} id='top-cml-id-3'>
                            <p className='data-label' id='top-cml-id-4'>{cell.label}</p>
                            <p className='data-value' id='top-cml-id-5'>
                                {typeof cell.content(cmlData) === 'string' && cell.content(cmlData).length > 10
                                    ? <Tooltip className='remanent-tooltip' placement='bottom'
                                        overlay={<div className='tooltip-content'>{cell.content(cmlData)}</div>}
                                        trigger={<Button style={{ padding: "0px" }} variant='transparent' onClick={() => { }}>{cell.content(cmlData).substring(0, 10)}...</Button>} />
                                    : cell.content(cmlData)}
                            </p>
                        </div>
                    ))
                }
            </div>
        </Card>
    )
}

export default TopCmlCard